import CityPageTemplate from "../city-template/CityPageTemplate";
import { mesquiteConfig } from "./data";

export default function MesquitePage() {
  return <CityPageTemplate config={mesquiteConfig} />;
}